import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./global-control-query-key-factory";

/**
 * get control catalog details by id uisng api call
 *
 * @param {string} catalogId - uuid of the control catalog
 * @returns control catalog object as array
 */
export const getControlCatalog = async ({ catalogId }: { catalogId: string }) => {
  return Brm.controlCatalogApi.getControlCatalogByID(catalogId);
};

interface IUseControlCatalog {
  catalogId: string;
  options?: QueryOption<typeof getControlCatalog>;
}

/**
 * React-query hook for getting  Control Catalog details by id
 *
 * @param {string} catalogId - uuid of the control Catalog
 * @param {object} options - configuration for useControlCatalog hook
 * @returns react-query for getControlCatalog
 */
export const useControlCatalog = ({ catalogId, options = {} }: IUseControlCatalog) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.controlCatalogKeys.catalog(catalogId),
    queryFn: () => getControlCatalog({ catalogId }),
  });
};
